import { Verified } from '@mui/icons-material';

type Props = {
  hideLabel?: boolean;
};

const OfficialBadge = ({ hideLabel }: Props) => {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-sm ${
        hideLabel ? 'px-1 py-0.5' : 'px-2.5 py-0.5'
      }`}
      title="Official"
    >
      <Verified className="w-4 h-4" />
      {!hideLabel && <span className="text-xs font-medium">Official</span>}
    </span>
  );
};

export default OfficialBadge;
